// extracted by mini-css-extract-plugin
module.exports = {"link":"arrow-link-module--link--2F9Dc","text":"arrow-link-module--text--2JP4z","arrow":"arrow-link-module--arrow--1C3hc"};